import { BaseModel } from "sjs-base-model";
import KaikoItemModel from "../filterableProducts/kaiko/KaikoItemModel";

// Returned Api Data sample
// const example = {
//     id: 1,
//     startDate: 20210101,
//     endDate: 20210102,
// };

export default class SubscriptionDateRangeModel extends BaseModel {
    id = 0;
    startDate = 0;
    endDate = 0;
    visibilityStartDate = 0;
    visibilityEndDate = 0;
    trial = false;
    salesTrial = false;
    isVisible = false;
    actualStartDate = 0;
    subscriptionRequestId = 0;
    levelTwoItems = [KaikoItemModel];

    constructor(data) {
        super();
        this.update(data);
    }
}